export default "__VITE_ASSET__DvSLHL7$__"